import { ListItem, ListItemText } from '@mui/material';
import React from 'react';
import { MarbleBlue } from 'src/Constants';
import { theme } from 'ui-sdk/src/theme';
import { MarbleText } from '../texts/Text';

interface ChatListItemProps {
  active: boolean;
  onClick: () => void;
  read?: boolean;
  title: string;
  secondaryTitle?: string;
  preview: string;
  timeSince?: string;
}

export const ChatListItem: React.FC<ChatListItemProps> = ({
  active,
  onClick,
  preview,
  read,
  title,
  secondaryTitle,
  timeSince,
}) => (
  <ListItem
    key={title}
    onClick={onClick}
    button
    style={{
      backgroundColor: active ? theme.colors.gray[5] : 'white',
      cursor: 'pointer',
      paddingLeft: theme.spacing(6),
      marginBlock: theme.spacing(2),
      borderRadius: 5,
      border: 1,
    }}
    selected={active}
  >
    {!read && (
      <div
        style={{
          backgroundColor: MarbleBlue,
          position: 'absolute',
          left: 10,
          height: '12px',
          width: '12px',
          borderRadius: '50%',
        }}
      />
    )}
    <ListItemText
      primary={<MarbleText weight="med">{title}</MarbleText>}
      secondary={
        <div>
          <MarbleText weight="med">{secondaryTitle}</MarbleText>
          <MarbleText style={{ opacity: '50%' }}>{preview}</MarbleText>
        </div>
      }
    />
    <ListItemText
      sx={{ opacity: '50%', textAlign: 'end', fontSize: '14px' }}
      primary={timeSince}
    />
  </ListItem>
);

interface NewChatListItemProps {
  active: boolean;
  onClick: () => void;
  read: boolean;
  title: string;
  subtitle: string;
  preview: string;
}

export const NewChatListItem: React.FC<NewChatListItemProps> = ({
  active,
  onClick,
  preview,
  read,
  title,
  subtitle,
}) => (
  <ListItem
    key={title}
    onClick={onClick}
    button
    style={{
      backgroundColor: active ? theme.colors.gray[5] : 'white',
      cursor: 'pointer',
      paddingLeft: theme.spacing(6),
      marginBlock: theme.spacing(2),
      borderRadius: 5,
      border: 1,
    }}
    selected={active}
  >
    {!read && (
      <div
        style={{
          backgroundColor: MarbleBlue,
          position: 'absolute',
          left: 10,
          height: '12px',
          width: '12px',
          borderRadius: '50%',
        }}
      />
    )}
    <ListItemText
      primary={<MarbleText weight="bold">{title}</MarbleText>}
      secondary={
        <div>
          <MarbleText weight="bold">{subtitle}</MarbleText>
          <MarbleText style={{ opacity: '50%' }}>{preview}</MarbleText>
        </div>
      }
    />
  </ListItem>
);
